module.exports = __webpack_public_path__ + "static/media/imcom-logo.0a3ee236.svg";